

import * as api from "../../../api"; 


  
export const getLeadsBySearchParameter = (post) => async (dispatch)=>{
    try {
        const {data } = await api.getLeadsBySearchParameter(post);
       
        
        
        return data 
     } catch (error) {
        // dispatch({
        //     type: "LOGINLEAD",
            
        //     payload:null
        //   });  
    }
}

